import PropTypes from 'prop-types'
import { Box, Text, VStack } from '@chakra-ui/react'
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { colors } from '../../utils/theme/styles'

export default function RequestError({ error }) {
  return (
    <Box>
      <VStack>
        <FontAwesomeIcon
          color={colors.log.error}
          icon={faCircleXmark}
          size="8x"
        />
        <Text>No se pudo realizar la acción:</Text>
        <Text variant="error" textAlign="center">
          {error}
        </Text>
        <Text>Para más información contactar a ejecutivo.</Text>
      </VStack>
    </Box>
  )
}

RequestError.propTypes = {
  error: PropTypes.string,
}
